import { render, staticRenderFns } from "./sectionM3.vue?vue&type=template&id=bfcd38c6&scoped=true&"
import script from "./sectionM3.vue?vue&type=script&lang=js&"
export * from "./sectionM3.vue?vue&type=script&lang=js&"
import style0 from "./sectionM3.vue?vue&type=style&index=0&id=bfcd38c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcd38c6",
  null
  
)

export default component.exports